import { useEffect, useState } from 'react';
import AdminLayout from '../../components/Layout/AdminLayout';
import { api } from '../../services/api';
import type { HelpContent } from '@vedjegy/shared';

export default function AdminHelpContentPage() {
  const [loading, setLoading]   = useState(true);
  const [saving,  setSaving]    = useState(false);
  const [saved,   setSaved]     = useState(false);
  const [error,   setError]     = useState('');

  const [form, setForm] = useState<HelpContent>({
    contactName:    null,
    contactEmail:   null,
    contactPhone:   null,
    contactExtra:   null,
    publicationUrl: null,
  });

  useEffect(() => {
    api.config.getHelp()
      .then((d) => setForm(d))
      .catch(() => setError('Nem sikerült betölteni a segítség tartalmat.'))
      .finally(() => setLoading(false));
  }, []);

  const set = (k: keyof HelpContent, v: string) =>
    setForm((f) => ({ ...f, [k]: v || null }));

  async function handleSave() {
    setSaving(true); setError(''); setSaved(false);
    try {
      await api.config.updateHelp(form);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch {
      setError('Mentés sikertelen.');
    } finally {
      setSaving(false);
    }
  }

  const labelStyle: React.CSSProperties = {
    display: 'block', fontSize: 12, fontWeight: 700,
    color: 'var(--secondary-foreground)', marginBottom: 4,
  };
  const inputStyle: React.CSSProperties = {
    width: '100%', boxSizing: 'border-box',
    padding: '8px 12px', fontSize: 14,
    border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
    background: '#fff', color: 'var(--primary)',
  };

  return (
    <AdminLayout>
      <div style={{ padding: '32px 40px', maxWidth: 680 }}>
        <h1 style={{ margin: '0 0 4px', fontSize: 22, fontWeight: 700, color: 'var(--primary)' }}>
          Segítség — kapcsolatfelvételi adatok
        </h1>
        <p style={{ margin: '0 0 28px', fontSize: 13, color: 'var(--muted-foreground)' }}>
          Ezek az adatok jelennek meg a pályázói felület "Segítség" gombjára kattintva.
        </p>

        {loading ? (
          <p style={{ color: 'var(--muted-foreground)' }}>Betöltés...</p>
        ) : (
          <div style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '28px 32px', boxShadow: 'var(--shadow-sm)', display: 'flex', flexDirection: 'column', gap: 18 }}>

            <div>
              <label style={labelStyle}>Kapcsolattartó neve</label>
              <input
                style={inputStyle}
                value={form.contactName ?? ''}
                onChange={(e) => set('contactName', e.target.value)}
                placeholder="pl. Kovács Péter"
              />
            </div>

            <div>
              <label style={labelStyle}>E-mail cím</label>
              <input
                style={inputStyle}
                type="email"
                value={form.contactEmail ?? ''}
                onChange={(e) => set('contactEmail', e.target.value)}
                placeholder="pl. info@kamara.hu"
              />
            </div>

            <div>
              <label style={labelStyle}>Telefonszám</label>
              <input
                style={inputStyle}
                value={form.contactPhone ?? ''}
                onChange={(e) => set('contactPhone', e.target.value)}
                placeholder="pl. +36 96 999 999"
              />
            </div>

            <div>
              <label style={labelStyle}>További információ / megjegyzés</label>
              <textarea spellCheck={true} lang="hu"
                style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }}
                value={form.contactExtra ?? ''}
                onChange={(e) => set('contactExtra', e.target.value)}
                placeholder="pl. Ügyfélfogadási idő: H–P 9–16"
              />
            </div>

            <div style={{ borderTop: '1px solid var(--border)', paddingTop: 18, marginTop: 4 }}>
              <label style={labelStyle}>Tavalyi kiadvány URL</label>
              <input
                style={inputStyle}
                type="url"
                value={form.publicationUrl ?? ''}
                onChange={(e) => set('publicationUrl', e.target.value)}
                placeholder="pl. https://74650727.flowpaper.com/VJ26/"
              />
              <p style={{ margin: '6px 0 0', fontSize: 12, color: 'var(--muted-foreground)' }}>
                Ha meg van adva, a pályázói felületen megjelenik a „Tavalyi kiadvány" link.
              </p>
            </div>

            {error && (
              <div style={{ fontSize: 13, color: '#c0392b' }}>{error}</div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 4 }}>
              <button
                className="btn btn-primary"
                onClick={() => void handleSave()}
                disabled={saving}
              >
                {saving ? 'Mentés...' : 'Mentés'}
              </button>
              {saved && (
                <span style={{ fontSize: 13, color: '#1a7a40' }}>✓ Mentve</span>
              )}
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
